export default function WhyBreakthru() {
  const benefits = [
    'Enterprise-grade system design',
    'Security-first architecture',
    'Compliance-aware automation',
    'Clear ROI and measurable impact',
    'No unnecessary tools or hype',
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-5 gap-16 items-center">
          <div className="lg:col-span-3 space-y-8">
            <div>
              <span className="inline-block px-4 py-1.5 border border-slate-300 text-slate-700 text-xs font-medium rounded-full mb-6">
                WHY BREAKTHRUAI
              </span>
              <h2 className="text-5xl font-bold text-slate-900 mb-8">
                Built for High-Trust Industries
              </h2>
            </div>

            <div className="space-y-5">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex items-center space-x-4">
                  <div className="w-6 h-6 rounded-full bg-teal-500 flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <span className="text-lg font-medium text-slate-800">{benefit}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-2">
            <div className="bg-slate-50 rounded-2xl p-10">
              <blockquote className="text-3xl font-light italic text-slate-600 leading-relaxed">
                "We engineer systems that work quietly and reliably behind the scenes."
              </blockquote>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
